import { TrackDef } from '../track.js';

/**
 * BOREAL REACH — Frozen night, advanced.
 * A drift clinic under the auroras: two chains of linked S-curves joined by a
 * wide crest over the icefield. Three patches of black ice wait on the corner
 * exits for anyone who straightens up too early.
 */
export const boreal: TrackDef = {
  id: 'boreal',
  name: 'Boreal Reach',
  tagline: 'Black ice and green skies. Feather the airbrakes and let the tail sing.',
  environment: 'aurora',
  difficulty: 3,
  layout: 'circuit',
  defaultLaps: 3,
  width: 25,
  unlockLevel: 6,
  points: [
    { x: 0, y: 50, z: 0, width: 26 },
    { x: -80, y: 52, z: 230, width: 24, roll: -0.28 },
    { x: 100, y: 56, z: 440, width: 23, roll: 0.32 },
    { x: -80, y: 60, z: 650, width: 23, roll: -0.32 },
    { x: 100, y: 64, z: 860, width: 24 },
    { x: 220, y: 68, z: 1080, width: 25, roll: -0.25 },
    { x: 470, y: 70, z: 1110, width: 28, roll: -0.28 },
    { x: 660, y: 66, z: 1000, width: 26, roll: -0.3 },
    { x: 740, y: 60, z: 800, width: 24, roll: -0.25 },
    { x: 650, y: 55, z: 540, width: 23, roll: 0.3 },
    { x: 760, y: 50, z: 340, width: 23, roll: -0.35 },
    { x: 650, y: 46, z: 150, width: 23, roll: 0.3 },
    { x: 740, y: 44, z: -40, width: 23, roll: -0.35 },
    { x: 570, y: 42, z: -270, width: 25, roll: -0.3 },
    { x: 320, y: 42, z: -340, width: 27 },
    { x: 80, y: 44, z: -300, width: 26, roll: -0.25 },
    { x: -50, y: 47, z: -190, width: 26, roll: -0.3 },
  ],
  features: [
    { kind: 'boost', s: 0.015, length: 0.007, lane: 0 },
    { kind: 'hazard', s: 0.14, length: 0.013, lane: 0.3, width: 9, type: 'slick' },
    { kind: 'boost', s: 0.28, length: 0.007, lane: -0.3 },
    { kind: 'zone', s: 0.33, length: 0.13, name: 'icefield' },
    { kind: 'boost', s: 0.52, length: 0.007, lane: 0.3 },
    { kind: 'hazard', s: 0.625, length: 0.013, lane: -0.3, width: 9, type: 'slick' },
    { kind: 'hazard', s: 0.8, length: 0.013, lane: -0.35, width: 9, type: 'slick' },
    { kind: 'boost', s: 0.87, length: 0.007, lane: 0 },
  ],
  medals: { bronze: 61.7, silver: 53.2, gold: 47.5, author: 44.1 },
};
